import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router/router'
import store from './store/store'
import { ValidationProvider, ValidationObserver, extend, setInteractionMode} from 'vee-validate/dist/vee-validate.full';
import { localize } from 'vee-validate/dist/vee-validate.full';
import en from 'vee-validate/dist/locale/en.json';
import el from 'vee-validate/dist/locale/el.json';


var locale = "el_GR";
if (document.getElementsByTagName("body")[0].getAttribute('data-locale') == 'en_US') {
  locale = "en_US";
}

store.commit("locale", locale);

extend('msisdn', (value) => {

  /* 
    This regular expression checks if input is a valid msisdn:
  */

  const regexp = /^69\d{8}$/gm;
  
  if (value.match(regexp)) {
    return true;
  }
  
  if (locale == "en_US") {
    return "The mobile number you filled in is incorrect. Please try again."
  } else {
    return "O αριθμός που συμπλήρωσες δεν είναι σωστός. Παρακαλούμε δοκίμασε ξανά."
  }

});

extend('password', (value) => {

  /* This regular expression checks for password which have:
    At least one uppercase latin letter
    At least one lowercase latin letter
    At least one number
    At least one special character @$!%*?&,.
    Length more than 6 chacracters
  */

  const regexp = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/gm;
  
  if (value.match(regexp)) {
    return true;
  }
  
  if (locale == "en_US") {
    return "The password is not valid"
  } else {
    return "Ο κωδικός δεν πληροί τους κανόνες ασφαλείας"
  }

  
});


localize({en,el});
localize({
  en: {
    messages: {
      // generic rule messages...
    },
    fields: {
      msisdn: {
        required: 'The field mobile number is required.'
      },
      otp: {
        required: 'The field temporary password is required.'
      },
      username: {
        required: 'The field Username* is required.'
      },
      email: {
        required: 'The field E-mail is required',
        email: 'The E-mail is not valid. Please try again.'
      },
      password: {
        required: 'The field Temporary Password* is required'
      },
      terms: {
        required: 'The field Terms and Conditions is required'
      }

    }
  },
  el: {
    messages: {
      // generic rule messages...
    },
    fields: {
      msisdn: {
        required: 'Συμπλήρωσε το πεδίο για να προχωρήσεις στην είσοδο στο FREE2GO Account.'
      },
      otp: {
        required: 'Συμπλήρωσε τον προσωρινό κωδικό που έλαβες για να προχωρήσεις στην είσοδο στο FREE2GO Account.'
      },
      username: {
        required: 'Παρακαλούμε συμπλήρωσε το πεδίο όνομα χρήστη.'
      },
      email: {
        required: 'Παρακαλούμε συμπλήρωσε το πεδίο email.',
        email: 'Το E-mail: που συμπλήρωσες δεν είναι σωστό. Παρακαλούμε δοκίμασε ξανά.'
      },
      password: {
        required: 'Παρακαλούμε συμπλήρωσε το πεδίο κωδικός χρήστη.'
      },
      terms: {
        required: 'To πεδίο Aποδέχομαι τους Όρους Χρήσης και την Πολιτική Προστασίας Ιδιωτικότητας πρέπει να συμπληρωθεί υποχρεωτικά'
      }
    }
  }
});


if (locale == 'en_US') {
  localize('en');
} else {
  localize('el');
}

setInteractionMode('eager');

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.use(VueAxios, axios);





Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')